/**
 * PDF export button for on-screen admin pump reports (captures charts via html2canvas).
 */
import { useState } from 'react';
import swal from 'sweetalert';
import { exportChunksToPdf, exportElementToPdf } from '../../../utils/exportReportPdf';

export default function AdminPumpReportExportButton({
  targetId,
  filename = 'report.pdf',
  label = 'Download PDF',
  className = 'btn btn-sm btn-outline-primary',
  disabled = false,
  metadata = {},
  title = 'Exporting PDF…',
  message = 'Capturing charts and tables from the screen. Please wait.',
  missingTargetMessage = 'Report is not loaded yet. Open the section and run the analysis first.',
  chunkSelector = '',
}) {
  const [exporting, setExporting] = useState(false);

  async function handleExport() {
    const element = document.getElementById(targetId);
    if (!element || !element.childElementCount) {
      swal('Export', missingTargetMessage, 'warning');
      return;
    }

    setExporting(true);
    swal({ title, text: message, buttons: false, closeOnClickOutside: false });

    try {
      if (chunkSelector) {
        await exportChunksToPdf(element, chunkSelector, filename, metadata);
      } else {
        await exportElementToPdf(element, filename, metadata);
      }
      swal.close();
    } catch (err) {
      swal.close();
      swal('Export failed', err.message || 'Could not generate PDF', 'error');
    } finally {
      setExporting(false);
    }
  }

  return (
    <button
      type="button"
      className={className}
      onClick={handleExport}
      disabled={disabled || exporting}
    >
      {exporting ? 'Exporting…' : label}
    </button>
  );
}
